export default __webpack_public_path__ + "images/industrial-icon@3x.png?ff99b44ab274b317f4e15fbf41d11a21";